import { Input } from '../../../../../../components/Common/UI/Input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../../../components/Common/UI/Select';
import { useMessageManagerProvider } from '../../../../../context/messageManager';

export enum ApplicationTypeEnum {
  quarterly = 'Quarterly',
  monthly = 'Monthly',
  annually = 'Annually',
}

export const applicationType: { key: keyof typeof ApplicationTypeEnum; label: string }[] = [
  { key: 'quarterly', label: ApplicationTypeEnum.quarterly },
  { key: 'monthly', label: ApplicationTypeEnum.monthly },
  { key: 'annually', label: ApplicationTypeEnum.annually },
];

function BuilderStepOne() {
  const { state, handleDispatch } = useMessageManagerProvider();

  const handleOnChange = (value: string) => {
    handleDispatch({ step1: { ...state.step1, companyName: value } });
  };

  const handleOnSelect = (value: string) => {
    handleDispatch({ step1: { ...state.step1, type: value as keyof typeof ApplicationTypeEnum } });
  };

  /** Set initial values moved to context */
  // useEffect(() => {
  //   if (!id) return;
  //
  //   handleDispatch({
  //     step1: { companyName: 'Test Campaign', type: 'monthly' },
  //     step2: {
  //       statement: {
  //         isEdit: true,
  //         data: builderStep2Data || [],
  //         statement: true,
  //         mode: 'image', // undefined // - Preset automatically first step as selected for update page
  //       },
  //       endOfStatement: {
  //         data: builderStep2DataEndOfStatement || [],
  //       },
  //     },
  //     step3: { isEdit: true, data: builderStep3Data },
  //     step4: { startDate: dayjs().toDate(), endDate: dayjs().add(1, 'week').toDate() },
  //   });
  //
  //   // pre-set second step.
  //   handleSelectedModule({ item: builderStep2Data[0], imageTabIndex: 0, textTabIndex: undefined });
  // }, []);

  return (
    <div className="bg-white shadow-lg max-w-[465px] border p-[30px] mx-auto self-center">
      <div className="mb-[25px] font-bold text-xl mt-[30px]">Enter Campaign Name</div>
      <Input
        placeholder="Campaign Name"
        className="mb-[10px]"
        onChange={e => handleOnChange(e.target.value)}
        value={state.step1.companyName}
        maxLength={75}
      />
      <div className="opacity-50 mb-[30px]">
        75 character limit. This name is NOT displayed on your statements. It is for personal use, help you identify
        each unique message.
      </div>
      <Select onValueChange={e => handleOnSelect(e)} value={state.step1.type}>
        <SelectTrigger variant="transparent">
          <SelectValue placeholder="Application type" />
        </SelectTrigger>
        <SelectContent>
          {applicationType.map(({ key, label }) => (
            <SelectItem key={key} value={key}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default BuilderStepOne;
